/**
 * @format
 */
export const QaMixin = {
    methods: {
        getDataLocator(postfix, ...additionalPostfixes) {
            let dataLocator;
            if (this.$options) {
                dataLocator = (this.$options.name || this.$options._componentTag);
            }
            if (!dataLocator) {
                dataLocator = 'unnamed';
            }
            dataLocator += '-component';

            if (postfix) {
                dataLocator += `-${postfix}`;
            }
            if (additionalPostfixes && additionalPostfixes.length > 0) {
                dataLocator += `-${additionalPostfixes.join('-')}`;
            }
            return dataLocator;
        },
    },
};
